



















































import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class WorkshopPage extends Vue {

  organizers = [
    {name:'Ning Xu', affiliation:'Adobe Research', im_name:'Ning_Xu'},
    {name:'Linjie Yang', affiliation:'Snap Research', im_name:'LinjieYang'},
    {name:'Yuchen Fan', affiliation:'UIUC', im_name:'YuchenFan'},
    {name: 'Weiyao Lin', affiliation: 'SJTU', im_name: 'WeiyaoLin'},
  ]

  speakers = [{
    name: 'Jason Corso',
    bio: `Corso is an associate professor of Electrical Engineering and Computer Science at the
    University of Michigan. From 2007-14 he was a member of the Computer Science and
    Engineering faculty at SUNY Buffalo.  He is the recipient of a Google Faculty Research Award
    2015, the Army Research Office Young Investigator Award 2010, NSF CAREER award 2009,
    SUNY Buffalo Young Investigator Award 2011, a member of the 2009 DARPA Computer Science
    Study Group, and a recipient of the Link Foundation Fellowship in Advanced Simulation and
    Training 2003. Corso has authored 90+ peer-reviewed papers on topics of his research interest
    including computer vision, robot perception, data science, and medical imaging. He is an
    Associate Editor of PAMI, and a member of the AAAI, IEEE, ACM.`,
    photo: 'JasonCorso',
  }, {
    name: 'Brian Price',
    bio: `Brian is a researcher in the Adobe Research Labs working in computer vision. He received his
    PhD degree in computer science from Brigham Young University in 2010, and his adviser was Dr. Bryan
    Morse. His PhD research focused on interactive image segmentation and matting in images and videos.
    Before that, he received his masters degree from the same institution under the guidance of Dr. 
    William Barrett.
    Brian joined Adobe in 2010 after completing his graduate work. His research interests include image
    and video segmentation and matting, interactive vision methods, stereo, and other computer vision
    fields, and well as broad interest in computer graphics and machine learning.`,
    photo: 'BrianPrice',
  }]
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/workshop.vue